module.exports = __webpack_public_path__ + "img/FR16433.016aee0b.svg";